export default "__VITE_ASSET__BSOl_YXN__"